<div class="forecast-management main-div-with-gray-bkg">
  <div class="row forecast-breadcrumb-div forecast-details-card tabs-styles">
    <div class="col-4 breadcrumb-style">
      <div class="height-separater">
        <nav aria-label="breadcrumb">
          <ol class="breadcrumb">
            <li class="breadcrumb-item"><a [routerLink]="['/landing-page']">Home</a></li>
            <li class="breadcrumb-item active" aria-current="page">Forecast Management</li>
            <li>
              <button
                [attr.Pixel-tracking]="true"
                [attr.Pixel-title]="'Documentation'"
                class="uitk-icon uitk-icon-info_hollow md-icon info-icon-border"
                title="Info"
                (click)="info()"
              ></button>
            </li>
          </ol>
        </nav>
      </div>
    </div>
  </div>
  <div class="row forecast-details-card ">
    <div class="col-md-12 col-sm-12 col-lg-12 col-xl-12 col-xs-12">
      <div class="d-flex">
        <mat-tab-group class="tab-group-width" (selectedTabChange)="tabChangeClick($event)">
          <mat-tab *ngFor="let tab of tabs" [label]="tab.label"> </mat-tab>
        </mat-tab-group>
        <div
          class="dropdown-container"
          [ngClass]="{ 'show-dropdown': showDropdown }"
          (mouseenter)="showDropdown = true"
          (mouseleave)="showDropdown = false"
        >
          <button
            class="dropdown-btn"
            [attr.Pixel-tracking]="true"
            [attr.Pixel-title]="'More Options'"
            class="teams-btn"
          >
            Need Help ?
          </button>
          <div class="dropdown-menu" *ngIf="showDropdown">
            <div class="dropdown-item" (click)="navigateToTeams()">
              <span class="d-flex align-items-center just-content-space-around">
                <img
                  src="../../../../assets/imagesV4/footer-Teams.svg"
                  mattooltip="Teams"
                  mattooltipposition="above"
                  class="mat-mdc-tooltip-trigger"
                />
                <span>Contact Us</span>
              </span>
            </div>
            <div class="dropdown-item" (click)="navigateToWatchDemo()">
              <span class="d-flex align-items-center just-content-space-around"
                ><mat-icon class="video_library">video_library</mat-icon> <span>Watch Demo</span></span
              >
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

  <div
    *ngIf="selectedTab == 'forecast_management'"
    class="forecast-details-card forecast-filters-structure"
    style="min-width:100%;"
  >
    <div class="dropdown-grid" style="min-width:100%;">
      <div class="ms-1 g-2 mat-chip-container p-1">
        <mat-chip-list>
          <mat-chip
            (click)="onChipClick('billing_segment')"
            class="chip-1"
            selected="true"
            removable="true"
            [ngClass]="{ 'active-chip': clickedChip === 'billing_segment' }"
            style="margin-right: 8px; color: white;"
          >
            <span class="chip-text">Billing Segment</span>
          </mat-chip>
          <mat-chip
            class="chip-2"
            selected="true"
            removable="true"
            (click)="selectAllOptions($event, 'chip2-options')"
            [ngClass]="{ 'active-chip': clickedChip === 'owners' }"
            style="margin-right: 8px; color: white; vertical-align: middle;"
          >
            <div class="d-flex flex-wrap align-items-center justify-content-between pt-2">
              <span class="ms-2">
                <input type="checkbox" id="SLO" name="chip2-options" value="SLO" class="checkboxstyle"
                  [checked]="selectedOwnerType.includes('SLO')" (change)="onOwnerTypeClick($event, 'SLO')" />
                <label for="SLO" class="chip-text">SLO</label>
              </span>
              <span class="ms-2">
                <input type="checkbox" id="BO" name="chip2-options" value="BO" class="checkboxstyle"
                  [checked]="selectedOwnerType.includes('BO')" (change)="onOwnerTypeClick($event, 'BO')" />
                <label for="BO" class="chip-text">BO</label>
              </span>
              <span class="ms-2">
                <input type="checkbox" id="TO" name="chip2-options" value="TO" class="checkboxstyle"
                  [checked]="selectedOwnerType.includes('TO')" (change)="onOwnerTypeClick($event, 'TO')" />
                <label for="TO" class="chip-text">TO</label>
              </span>
            </div>
          </mat-chip>
          <mat-chip
            (click)="onChipClick('delegate')"
            class="chip-3"
            selected="true"
            removable="true"
            [ngClass]="{ 'active-chip': clickedChip === 'delegate' }"
            style="margin-right: 8px; color: white;"
          >
            <span class="chip-text">Delegate</span>
          </mat-chip>
        </mat-chip-list>
      </div>
      <div
        *ngIf="isChipClicked"
        class="row main-div-with-white-bkg forecast-details-card portfoliohub-main-div-with-gray-bkg-margin portfolio-details-card-segment"
        style="align-items:center"
      >
        <div style="width:28%;" class="p-2" *ngIf="clickedChip == 'billing_segment'">
          <app-hierarchy-dropdown
            [dropdownData]="lobSublobListForDropdown"
            [initialSelectedItems]="initialSelectedLobString"
            [filterKey]="'L1:L2'"
            [resetTrigger]="resetTrigger"
            (selectionChange)="selectedSegment($event)"
            [placeholderText]="'Select Billing Segment'"
          ></app-hierarchy-dropdown>
        </div>
        <div class="leader-individual-dropdown-width p-0" *ngIf="clickedChip == 'owners'">
          <input
            type="text"
            class="search-option table-data-font search-box leader-search"
            (keyup)="searchLeader($event, selectedOwnerType); $event.stopPropagation()"
            [(ngModel)]="leaderSearch"
            placeholder="Type min 3 chars to search Leader/App Owner"
            [disabled]="leaderAppOwnerSearchDisabled"
          />
          <img class="leader-search leader-search-icon" src="../../../../assets/images/searchicon.png" />
          <div [@openClose]="showLeaderList" id="menu" *ngIf="showLeaderList" class="list-container">
            <div class="leader-results-count-div">
              <span class="search-list-header" *ngIf="leaderList.length > 0 && !showLeaderListLoader"
                >{{ leaderList.length }} Results Found</span
              >

              <span class="search-list-header" *ngIf="leaderList.length == 0 && !showLeaderListLoader">
                No Results Found
              </span>
              <mat-icon (click)="showLeaderList = false" class="leader-results-close-icon">close</mat-icon>
            </div>
            <ul class="list-group leader-names-list">
              <ng-container *ngIf="showLeaderListLoader; else showlist">
                <button *ngFor="let i of [1, 2, 3, 4, 5]" class="list-group-item list-item">
                  <mat-progress-bar mode="buffer" class="dark-blue"></mat-progress-bar>
                </button>
              </ng-container>
              <ng-template #showlist>
                <span
                  *ngFor="let leader of leaderList"
                  class="leader-list"
                  [title]="leader.Leader_Msid ? leader.Leader_Msid : leader.Owner_msid ? leader.Owner_msid : ''"
                >
                  <!-- <span class="leader-result-level" *ngIf="leader.Leader_Level">L{{ leader.Leader_Level }}</span>
                      <span class="leader-result-level app-owner" *ngIf="!leader.Leader_Level">AO</span> -->
                  <label class="leader-result-name mb-1">{{ leader.name | uppercase }}</label>
                  <div class="ps-5 note mb-2" (click)="setSelectedValues(leader, 'leader')" *ngIf="leader.isLeader">
                    Do you want to explore apps under this Leader?
                  </div>
                  <div class="ps-5 note" (click)="setSelectedValues(leader, 'owner')" *ngIf="leader.isOwner">
                    Do you want to explore apps under this Owner?
                  </div>
                </span>
              </ng-template>
            </ul>
          </div>
        </div>

        <div class="leader-individual-dropdown-width p-0" *ngIf="clickedChip == 'delegate'">
          <input
            type="text"
            class="search-option table-data-font search-box leader-search"
            (keyup)="searchDelegates($event); $event.stopPropagation()"
            [(ngModel)]="leaderSearch"
            placeholder="Type min 3 chars to search delegate"
          />
          <img class="leader-search leader-search-icon" src="../../../../assets/images/searchicon.png" />
          <div [@openClose]="showLeaderList" id="menu" *ngIf="showLeaderList" class="list-container">
            <div class="leader-results-count-div">
              <span class="search-list-header" *ngIf="leaderList.length > 0 && !showLeaderListLoader"
                >{{ leaderList.length }} Results Found</span
              >

              <span class="search-list-header" *ngIf="leaderList.length == 0 && !showLeaderListLoader">
                No Results Found
              </span>
              <mat-icon (click)="showLeaderList = false" class="leader-results-close-icon">close</mat-icon>
            </div>
            <ul class="list-group leader-names-list">
              <ng-container *ngIf="showLeaderListLoader; else showlist">
                <button *ngFor="let i of [1, 2, 3, 4, 5]" class="list-group-item list-item">
                  <mat-progress-bar mode="buffer" class="dark-blue"></mat-progress-bar>
                </button>
              </ng-container>
              <ng-template #showlist>
                <span
                  (click)="setSelectedValues(leader, 'delegate')"
                  *ngFor="let leader of leaderList"
                  class="leader-list"
                  [title]="leader.Leader_Msid ? leader.Leader_Msid : leader.Owner_msid ? leader.Owner_msid : ''"
                >
                  <!-- <span class="leader-result-level" *ngIf="leader.Leader_Level">L{{ leader.Leader_Level }}</span>
                        <span class="leader-result-level app-owner" *ngIf="!leader.Leader_Level">AO</span> -->
                  <label class="leader-result-name mb-1">{{ leader.name | uppercase }}</label>
                </span>
              </ng-template>
            </ul>
          </div>
        </div>

        <div style="width:20%;" class="p-0">
          <app-dropdown-with-search
            [Pixeltracking]="true"
            [placeholder]="placeholders['services']"
            searchFlag="true"
            isMultiSelect="true"
            [dropdownData]="servicesData"
            [selected]="selectedValues['services']"
            (selectionChange)="setSelectedValues($event, 'service')"
            [disableDD]="disableDD"
            [isFromForecast]="true"
          ></app-dropdown-with-search>
        </div>
        <div style="width:20%;" class="p-0">
          <app-dropdown-with-search
            [Pixeltracking]="true"
            [placeholder]="placeholders['apps']"
            searchFlag="true"
            isMultiSelect="true"
            [dropdownData]="appsData"
            [selected]="selectedValues['apps']"
            (selectionChange)="setSelectedValues($event, 'apps')"
            [disableDD]="disableDD"
            [isFromForecast]="true"
          ></app-dropdown-with-search>
        </div>
        <div style="width:20%;" class="p-0">
          <app-dropdown-with-search
            [Pixeltracking]="true"
            [placeholder]="placeholders['lifecycle']"
            searchFlag="false"
            isMultiSelect="true"
            [dropdownData]="lifeCycleData"
            [selected]="selectedValues['lifecycle']"
            (selectionChange)="setSelectedValues($event, 'lifecycle')"
            [disableDD]="disableDD"
            [isFromForecast]="true"
          ></app-dropdown-with-search>
        </div>
        <div style="width:12%;" class="buttons-div pt-2">
          <div class="d-flex portfolio-hub-icons portfolio-padding-icons">
            <button
              [attr.Pixel-tracking]="true"
              [attr.Pixel-title]="'Search'"
              [disabled]="disableSearch"
              (click)="search()"
              class="removebuttonClass m-1 uitk-c-button uitk-c-button--default mat-mdc-raised-button techops-global-button uitk-u-margin-right--base uitk-u-margin-bottom--xs"
            >
              Search
            </button>
            <button
              [disabled]="disableReset"
              class="removebuttonClass m-1 uitk-c-button uitk-c-button--default mat-mdc-raised-button techops-global-button uitk-u-margin-right--base uitk-u-margin-bottom--xs"
              (click)="reset()"
            >
              Reset
            </button>
          </div>
        </div>
      </div>
      <!-- <div class="new-app-block">
        <div *ngIf="isChipClicked && showAddNewAppButton && showAddNewAppButtonByRole && !isForecastTableDataLoaded" class="pt-2 app-block-btn">
          <button
          class=" cancelbuttonClass my-1 ms-1 me-1 uitk-c-button uitk-c-button--default mat-mdc-raised-button techops-global-button uitk-u-margin-right--base uitk-u-margin-bottom--xs"
          (click)="addNewApplicationService()">
          Add New Application</button>
        </div>
        <p class="general-txt" [hidden]="SearchLength!=0 || selectedTab != 'forecast_management'">Please select atleast one dropdown to view details</p>

      </div> -->

      <div class="new-app-block" [ngClass]="{
          'general-txt-position': !(isChipClicked && showAddNewAppButton && showAddNewAppButtonByRole && !isForecastTableDataLoaded)
        }">
        <div class="row mt-2">
          <div class="col-12 col-sm-6 col-md-3 col-lg-3 col-xl-3">
            <div *ngIf="isChipClicked && showAddNewAppButton && showAddNewAppButtonByRole && !isForecastTableDataLoaded"
              class="pt-2 app-block-btn">
              <button
                class="cancelbuttonClass my-1 ms-1 me-1 uitk-c-button uitk-c-button--default mat-mdc-raised-button techops-global-button uitk-u-margin-right--base uitk-u-margin-bottom--xs"
                (click)="addNewApplicationService()">
                Add New Application
              </button>
            </div>
          </div>

          <div class="col-12 col-sm-6 col-md-6 col-lg-6 col-xl-6">
            <p class="general-txt" [hidden]="SearchLength != 0 || selectedTab != 'forecast_management'">
              Please select at least one dropdown to view details
            </p>
          </div>
        </div>
      </div>

      <div style="width:100%" class="ps-2 pe-2">
        <app-forecast-detail-card *ngIf="forecastDetailsMap?.size>10 && isForecastTableDataLoaded"
          [forecastDetailsMap]="forecastDetailsMap"></app-forecast-detail-card>
        <app-forcast-management-table [RealFilter]="selectedValues"
          [isForecastTableDataLoaded]="isForecastTableDataLoaded" [forecastDetailsMap]="forecastDetailsMap"
          [forecastTableData]="forecastTableData" [TABLE_CONFIG]="TABLE_CONFIG" [COLUMNS]="TABLE_COLUMNS"
          [expanded_columns]="expanded_columns" [isForecastTableUpdated]="isForecastTableUpdated"
          [pageSize]="TABLE_CONFIG.pageSize" [pageIndex]="TABLE_CONFIG.pageIndex"
          (updateExpandedColData)="onToggleChange($event)" [masterServicesData]="masterServicesData"
          (refreshAggregatedData)="getAgrregatedForecastDetails($event)" [isForecastAdmin]="isForecastAdmin"
          [isForecastSRM]="isForecastSRM"
          [forecastCycleType]="forecastCycleType" [clickedChip]="clickedChip" [selectedOwnerType]="selectedOwnerType"
          [isLeaderOrOwnerSelected]="isLeaderOrOwnerSelected">
        </app-forcast-management-table>
      </div>
      <div class="stk-table-loader forecast-loader" *ngIf="showLoader || filtersLoader">
        <app-loader> </app-loader>
      </div>
    </div>
  </div>
  <div
    *ngIf="selectedTab == 'segment_relationship'"
    class="forecast-details-card forecast-filters-structure-srm"
    style="min-width:100%;"
  >
    <app-forecast-segment-relationship
      [segmentData]="lobSublobListForDropdown"
      [isForecastAdmin]="isForecastAdmin"
    ></app-forecast-segment-relationship>
  </div>
  <div *ngIf="selectedTab == 'master_table_management'">
    <app-forecast-admin-management
      [isForecastAdmin]="isForecastAdmin"
      [segmentData]="lobSublobListForDropdown"
    ></app-forecast-admin-management>
  </div>
  <div *ngIf="selectedTab == 'bulk_forecast'">
    <app-bulk-forecast [isForecastAdmin]="isForecastAdmin"></app-bulk-forecast>
  </div>
  <div *ngIf="selectedTab && !(selectedTab == 'forecast_management' || selectedTab == 'segment_relationship' || selectedTab == 'bulk_forecast' || selectedTab == 'master_table_management' || selectedTab == 'bulk_forecast') ">
    <app-inbuilt-report-v2 [reportNameFromInput]="selectedTab"></app-inbuilt-report-v2>
  </div>
  <!-- <app-search-view-default-text [hidden]="SearchLength!=0 || selectedTab != 'forecast_management'"
    [viewName]="'atleast one dropdown'" ></app-search-view-default-text> -->
  <div
    class="timeline-container"
    [hidden]="SearchLength != 0 || selectedTab != 'forecast_management'"
    *ngIf="forecastCycleType && forecastCycleType?.msg"
  >
    <!-- Left side image-->
    <div class="image-selection">
      <img src="../../../../assets/imagesV4/sideimg.png" alt="Profile" class="side-image" />
    </div>
    <!-- Right side image-->
    <div class="timeline w-100">
      <p class="timeline-heading">Forecast Management</p>
      <div class="step-container">
        <ng-container *ngFor="let step of steps; let i = index">
          <div class="step" 
          [ngClass]="{
                  green: step?.status == 'done',
                  blue: step?.status == 'current',
                  grey: step?.status == 'pending'
                }">
            <div class="label">{{ step.label }}</div>
            <div class="icon-wrapper">
              <mat-icon
                class="tick"
                
                >{{step?.status == 'done' ? 'check_circle' : 'adjust'}}</mat-icon
              >
              <div class="line" *ngIf="i < 2"></div>
            </div>
            <span class="forecast-cycle-chip">{{step?.pillText}}</span>
          </div>
        </ng-container>
      </div>
      <div class="forecast-cycle-text-block">
        <p class="forecast-msg" [ngClass]="forecastCycleType?.type">{{ forecastCycleType?.msg }}</p>
        <p class="forecast-submsg" [ngClass]="forecastCycleType?.type" *ngIf="forecastCycleType?.submsg">
          {{ forecastCycleType?.submsg }}
        </p>
      </div>
    </div>
  </div>
</div>

<app-modal [maximizable]="true" [inViewport]="true" #addServicePopup class="modal-demo add-service-popup">
  <ng-container class="app-modal-header">Add New Application</ng-container>
  <ng-container class="app-modal-body">
    <app-forecast-add-service-popup
      [masterServicesData]="masterServicesData"
      [allNewApps]="allNewApps"
      [modalType]="modalType"
      (refreshService)="refreshServicesForApp()"
    >
    </app-forecast-add-service-popup>
  </ng-container>
</app-modal>
